import Header from "@src/components/shared/Header";

function Layout({ children }: { children?: JSX.Element | JSX.Element[] }) {
  return (
    <div className="min-h-[100vh]">
      <Header />
      {children}
    </div>
  );
}

export default Layout;
